import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { ISideBar } from "../../models/storeModels/ISideBar";
import { getItemWebStorage } from "../../features/webStorageSaver";
import { logout } from "../../features/auth";

function getInitialState() {
    const sidebarLocalSettings = getItemWebStorage('sidebar')
    const { menuStructure, menuPath, isShown } = sidebarLocalSettings ?? {}
    const initialState: ISideBar = {
        sidebarMenuStructure: menuStructure ?? [],
        sidebarMenuPath: menuPath ?? [],
        sidebarIsShown: isShown ?? true,
        isUserMessageWindowOpened: false
    }
    return initialState
}

export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: getInitialState(),
    reducers: {
        setSidebarMenuStructure(state, action: PayloadAction<any>) {
            state.sidebarMenuStructure = action.payload
        },
        setSidebarMenuPath(state, action: PayloadAction<any>) {
            state.sidebarMenuPath = action.payload
        },
        setSidebarIsShown(state, action: PayloadAction<any>) {
            state.sidebarIsShown = action.payload
        },
        applyUserMessageWindowOpened(state, action: PayloadAction<any>) {
            state.isUserMessageWindowOpened = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { setSidebarMenuStructure, setSidebarMenuPath, setSidebarIsShown, applyUserMessageWindowOpened } = sidebarSlice.actions
export const sidebarReducer = sidebarSlice.reducer;
